// Derived from routes.tsx. The route coverage test guards this catalog against drift.
import * as Dtos from "src/dtos/Tmd.dtos";
export const helpRouteCatalog = [
    {
        "id": "dashboard",
        "path": "/dashboard",
        "topicKey": "dashboard"
    },
    {
        "id": "dashboard-preview",
        "path": "/dashboard-preview",
        "topicKey": "dashboard"
    },
    {
        "id": "my-trial-institutions",
        "path": "/my-trial-institutions",
        "topicKey": "dashboard"
    },
    {
        "id": "search",
        "path": "/search",
        "topicKey": "search"
    },
    {
        "id": "mytrials",
        "path": "/mytrials",
        "topicKey": "my-trials"
    },
    {
        "id": "settings",
        "path": "/settings",
        "topicKey": "settings"
    },
    {
        "id": "settings.general",
        "path": "/settings/general",
        "topicKey": "general-settings"
    },
    {
        "id": "settings.general.countries",
        "path": "/settings/general/countries",
        "topicKey": "countries"
    },
    {
        "id": "settings.general.countries.countryId",
        "path": "/settings/general/countries/:countryId",
        "topicKey": "country"
    },
    {
        "id": "settings.general.roles",
        "path": "/settings/general/roles",
        "topicKey": "roles"
    },
    {
        "id": "settings.general.roles.roleId",
        "path": "/settings/general/roles/:roleId",
        "topicKey": "role"
    },
    {
        "id": "settings.general.states",
        "path": "/settings/general/states",
        "topicKey": "states"
    },
    {
        "id": "settings.general.states.stateId",
        "path": "/settings/general/states/:stateId",
        "topicKey": "state"
    },
    {
        "id": "settings.general.itemcomponenttypes",
        "path": "/settings/general/itemcomponenttypes",
        "topicKey": "item-component-types"
    },
    {
        "id": "settings.general.itemcomponenttypes.itemcomponenttypesId",
        "path": "/settings/general/itemcomponenttypes/:itemcomponenttypesId",
        "topicKey": "item-component-type"
    },
    {
        "id": "settings.general.notetypes",
        "path": "/settings/general/notetypes",
        "topicKey": "note-types"
    },
    {
        "id": "settings.general.notetypes.notetypesId",
        "path": "/settings/general/notetypes/:notetypesId",
        "topicKey": "note-type"
    },
    {
        "id": "settings.general.interests",
        "path": "/settings/general/interests",
        "topicKey": "interests"
    },
    {
        "id": "settings.general.interests.interestId",
        "path": "/settings/general/interests/:interestId",
        "topicKey": "interest"
    },
    {
        "id": "settings.general.membershiptypes",
        "path": "/settings/general/membershiptypes",
        "topicKey": "membership-types"
    },
    {
        "id": "settings.general.membershiptypes.membershiptypesId",
        "path": "/settings/general/membershiptypes/:membershiptypesId",
        "topicKey": "membership-type"
    },
    {
        "id": "settings.general.professionaldisciplines",
        "path": "/settings/general/professionaldisciplines",
        "topicKey": "professional-disciplines"
    },
    {
        "id": "settings.general.professionaldisciplines.professionaldisciplinesId",
        "path": "/settings/general/professionaldisciplines/:professionaldisciplinesId",
        "topicKey": "professional-discipline"
    },
    {
        "id": "settings.general.salutations",
        "path": "/settings/general/salutations",
        "topicKey": "salutations"
    },
    {
        "id": "settings.general.salutations.salutationId",
        "path": "/settings/general/salutations/:salutationId",
        "topicKey": "salutation"
    },
    {
        "id": "settings.project",
        "path": "/settings/project",
        "topicKey": "project-settings"
    },
    {
        "id": "settings.project.itemtemplates",
        "path": "/settings/project/itemtemplates",
        "topicKey": "project-item-templates"
    },
    {
        "id": "settings.project.itemtemplates.projectItemTemplateId",
        "path": "/settings/project/itemtemplates/:projectItemTemplateId",
        "topicKey": "project-item-template"
    },
    {
        "id": "settings.project.itemcomponents",
        "path": "/settings/project/itemcomponents",
        "topicKey": "item-components"
    },
    {
        "id": "settings.project.itemcomponents.itemComponentId",
        "path": "/settings/project/itemcomponents/:itemComponentId",
        "topicKey": "item-component"
    },
    {
        "id": "settings.project.itemCategories",
        "path": "/settings/project/itemCategories",
        "topicKey": "project-item-template-categorys"
    },
    {
        "id": "settings.project.itemCategories.projectItemTemplateCategoryId",
        "path": "/settings/project/itemCategories/:projectItemTemplateCategoryId",
        "topicKey": "project-item-template-category"
    },
    {
        "id": "settings.trial",
        "path": "/settings/trial",
        "topicKey": "trial-settings"
    },
    {
        "id": "settings.trial.itemtemplates",
        "path": "/settings/trial/itemtemplates",
        "topicKey": "trial-item-templates"
    },
    {
        "id": "settings.trial.itemtemplates.trialId",
        "path": "/settings/trial/itemtemplates/:trialId",
        "topicKey": "trial-item-templates"
    },
    {
        "id": "settings.trial.itemtemplates.trialId.template.trialItemTemplateId",
        "path": "/settings/trial/itemtemplates/:trialId/template/:trialItemTemplateId",
        "topicKey": "trial-item-template"
    },
    {
        "id": "settings.trial.itemtemplates.template.trialItemTemplateId",
        "path": "/settings/trial/itemtemplates/template/:trialItemTemplateId",
        "topicKey": "trial-item-template"
    },
    {
        "id": "settings.trial.itemcomponents",
        "path": "/settings/trial/itemcomponents",
        "topicKey": "item-components"
    },
    {
        "id": "settings.trial.itemcomponents.itemComponentId",
        "path": "/settings/trial/itemcomponents/:itemComponentId",
        "topicKey": "item-component"
    },
    {
        "id": "settings.trial.itemtemplatecategories",
        "path": "/settings/trial/itemtemplatecategories",
        "topicKey": "trial-item-template-categories"
    },
    {
        "id": "settings.trial.itemtemplatecategories.trialItemTemplateCategoryId",
        "path": "/settings/trial/itemtemplatecategories/:trialItemTemplateCategoryId",
        "topicKey": "trial-item-template-category"
    },
    {
        "id": "settings.trial.trialtypes",
        "path": "/settings/trial/trialtypes",
        "topicKey": "trial-types"
    },
    {
        "id": "settings.trial.trialtypes.trialTypeId",
        "path": "/settings/trial/trialtypes/:trialTypeId",
        "topicKey": "trial-type"
    },
    {
        "id": "settings.trialinstitution",
        "path": "/settings/trialinstitution",
        "topicKey": "trial-institution-settings"
    },
    {
        "id": "settings.trialinstitution.itemtemplates",
        "path": "/settings/trialinstitution/itemtemplates",
        "topicKey": "trial-institution-item-templates"
    },
    {
        "id": "settings.trialinstitution.itemtemplates.trialId",
        "path": "/settings/trialinstitution/itemtemplates/:trialId",
        "topicKey": "trial-institution-item-templates"
    },
    {
        "id": "settings.trialinstitution.itemtemplates.trialId.template.trialInstitutionItemTemplateId",
        "path": "/settings/trialinstitution/itemtemplates/:trialId/template/:trialInstitutionItemTemplateId",
        "topicKey": "trial-institution-item-template"
    },
    {
        "id": "settings.trialinstitution.itemtemplates.template.trialInstitutionItemTemplateId",
        "path": "/settings/trialinstitution/itemtemplates/template/:trialInstitutionItemTemplateId",
        "topicKey": "trial-institution-item-template"
    },
    {
        "id": "settings.trialinstitution.itemcomponents",
        "path": "/settings/trialinstitution/itemcomponents",
        "topicKey": "item-components"
    },
    {
        "id": "settings.trialinstitution.itemcomponents.itemComponentId",
        "path": "/settings/trialinstitution/itemcomponents/:itemComponentId",
        "topicKey": "item-component"
    },
    {
        "id": "settings.trialinstitution.itemtemplatecategories",
        "path": "/settings/trialinstitution/itemtemplatecategories",
        "topicKey": "trial-institution-item-template-categories"
    },
    {
        "id": "settings.trialinstitution.itemtemplatecategories.trialInstitutionItemTemplateCategoryId",
        "path": "/settings/trialinstitution/itemtemplatecategories/:trialInstitutionItemTemplateCategoryId",
        "topicKey": "trial-institution-item-template-category"
    },
    {
        "id": "settings.trialgroup",
        "path": "/settings/trialgroup",
        "topicKey": "trial-group-settings"
    },
    {
        "id": "settings.trialgroup.itemtemplates",
        "path": "/settings/trialgroup/itemtemplates",
        "topicKey": "trial-group-item-templates"
    },
    {
        "id": "settings.trialgroup.itemtemplates.groupId",
        "path": "/settings/trialgroup/itemtemplates/:groupId",
        "topicKey": "trial-group-item-templates"
    },
    {
        "id": "settings.trialgroup.itemtemplates.groupId.template.trialGroupItemTemplateId",
        "path": "/settings/trialgroup/itemtemplates/:groupId/template/:trialGroupItemTemplateId",
        "topicKey": "trial-group-item-template"
    },
    {
        "id": "settings.trialgroup.itemtemplates.template.trialGroupItemTemplateId",
        "path": "/settings/trialgroup/itemtemplates/template/:trialGroupItemTemplateId",
        "topicKey": "trial-group-item-template"
    },
    {
        "id": "settings.trialgroup.itemcomponents",
        "path": "/settings/trialgroup/itemcomponents",
        "topicKey": "item-components"
    },
    {
        "id": "settings.trialgroup.itemcomponents.itemComponentId",
        "path": "/settings/trialgroup/itemcomponents/:itemComponentId",
        "topicKey": "item-component"
    },
    {
        "id": "settings.trialgroup.itemtemplatecategories",
        "path": "/settings/trialgroup/itemtemplatecategories",
        "topicKey": "trial-group-item-template-categories"
    },
    {
        "id": "settings.trialgroup.itemtemplatecategories.trialGroupItemTemplateCategoryId",
        "path": "/settings/trialgroup/itemtemplatecategories/:trialGroupItemTemplateCategoryId",
        "topicKey": "trial-group-item-template-category"
    },
    {
        "id": "settings.group",
        "path": "/settings/group",
        "topicKey": "group-settings"
    },
    {
        "id": "settings.group.itemtemplates",
        "path": "/settings/group/itemtemplates",
        "topicKey": "group-item-templates"
    },
    {
        "id": "settings.group.itemtemplates.groupId",
        "path": "/settings/group/itemtemplates/:groupId",
        "topicKey": "group-item-templates"
    },
    {
        "id": "settings.group.itemtemplates.groupId.template.groupItemTemplateId",
        "path": "/settings/group/itemtemplates/:groupId/template/:groupItemTemplateId",
        "topicKey": "group-item-template"
    },
    {
        "id": "settings.group.itemtemplates.template.groupItemTemplateId",
        "path": "/settings/group/itemtemplates/template/:groupItemTemplateId",
        "topicKey": "group-item-template"
    },
    {
        "id": "settings.group.itemcomponents",
        "path": "/settings/group/itemcomponents",
        "topicKey": "item-components"
    },
    {
        "id": "settings.group.itemcomponents.itemComponentId",
        "path": "/settings/group/itemcomponents/:itemComponentId",
        "topicKey": "item-component"
    },
    {
        "id": "settings.group.itemCategories",
        "path": "/settings/group/itemCategories",
        "topicKey": "group-item-template-categorys"
    },
    {
        "id": "settings.group.itemCategories.groupItemTemplateCategoryId",
        "path": "/settings/group/itemCategories/:groupItemTemplateCategoryId",
        "topicKey": "group-item-template-category"
    },
    {
        "id": "settings.institution",
        "path": "/settings/institution",
        "topicKey": "institution-settings"
    },
    {
        "id": "settings.institution.itemtemplates",
        "path": "/settings/institution/itemtemplates",
        "topicKey": "institution-item-templates"
    },
    {
        "id": "settings.institution.itemtemplates.institutionId",
        "path": "/settings/institution/itemtemplates/:institutionId",
        "topicKey": "institution-item-templates"
    },
    {
        "id": "settings.institution.itemtemplates.institutionId.template.institutionItemTemplateId",
        "path": "/settings/institution/itemtemplates/:institutionId/template/:institutionItemTemplateId",
        "topicKey": "institution-item-template"
    },
    {
        "id": "settings.institution.itemtemplates.template.institutionItemTemplateId",
        "path": "/settings/institution/itemtemplates/template/:institutionItemTemplateId",
        "topicKey": "institution-item-template"
    },
    {
        "id": "settings.institution.itemcomponents",
        "path": "/settings/institution/itemcomponents",
        "topicKey": "item-components"
    },
    {
        "id": "settings.institution.itemcomponents.itemComponentId",
        "path": "/settings/institution/itemcomponents/:itemComponentId",
        "topicKey": "item-component"
    },
    {
        "id": "settings.institution.itemtemplatecategories",
        "path": "/settings/institution/itemtemplatecategories",
        "topicKey": "institution-item-template-categories"
    },
    {
        "id": "settings.institution.itemtemplatecategories.institutionItemTemplateCategoryId",
        "path": "/settings/institution/itemtemplatecategories/:institutionItemTemplateCategoryId",
        "topicKey": "institution-item-template-category"
    },
    {
        "id": "settings.institution.sitelocations",
        "path": "/settings/institution/sitelocations",
        "topicKey": "site-locations"
    },
    {
        "id": "settings.institution.sitelocations.siteLocationId",
        "path": "/settings/institution/sitelocations/:siteLocationId",
        "topicKey": "site-location"
    },
    {
        "id": "settings.institution.keycontacts",
        "path": "/settings/institution/keycontacts",
        "topicKey": "key-contacts"
    },
    {
        "id": "settings.institution.keycontacts.keyContactId",
        "path": "/settings/institution/keycontacts/:keyContactId",
        "topicKey": "key-contact"
    },
    {
        "id": "settings.institution.institutiontypes",
        "path": "/settings/institution/institutiontypes",
        "topicKey": "institution-types"
    },
    {
        "id": "settings.institution.institutiontypes.institutionTypeId",
        "path": "/settings/institution/institutiontypes/:institutionTypeId",
        "topicKey": "institution-type"
    },
    {
        "id": "settings.institution.institutioncodings",
        "path": "/settings/institution/institutioncodings",
        "topicKey": "institution-codings"
    },
    {
        "id": "settings.institution.institutioncodings.institutionCodingId",
        "path": "/settings/institution/institutioncodings/:institutionCodingId",
        "topicKey": "institution-coding"
    },
    {
        "id": "settings.hrecs",
        "path": "/settings/hrecs",
        "topicKey": "hrecs"
    },
    {
        "id": "settings.hrecs.hrecId.details",
        "path": "/settings/hrecs/:hrecId/details",
        "topicKey": "hrec"
    },
    {
        "id": "settings.healthdistricts",
        "path": "/settings/healthdistricts",
        "topicKey": "health-districts"
    },
    {
        "id": "settings.healthdistricts.healthDistrictId.details",
        "path": "/settings/healthdistricts/:healthDistrictId/details",
        "topicKey": "health-district"
    },
    {
        "id": "trials",
        "path": "/trials",
        "topicKey": "trials"
    },
    {
        "id": "trials.trialId.details",
        "path": "/trials/:trialId/details",
        "topicKey": "trial"
    },
    {
        "id": "trials.trialId.institutions",
        "path": "/trials/:trialId/institutions",
        "topicKey": "trial-institutions"
    },
    {
        "id": "trials.trialId.trialinstitution.trialInstitutionId.details",
        "path": "/trials/:trialId/trialinstitution/:trialInstitutionId/details",
        "topicKey": "trial-institution"
    },
    {
        "id": "trials.trialId.trialinstitution.trialInstitutionId.items",
        "path": "/trials/:trialId/trialinstitution/:trialInstitutionId/items",
        "topicKey": "trial-institution-items"
    },
    {
        "id": "trials.trialId.trialinstitution.trialInstitutionId.personnel",
        "path": "/trials/:trialId/trialinstitution/:trialInstitutionId/personnel",
        "topicKey": "trial-institution-personnels"
    },
    {
        "id": "trials.trialId.trialinstitution.trialInstitutionId.personnel.personnelId.details",
        "path": "/trials/:trialId/trialinstitution/:trialInstitutionId/personnel/:personnelId/details",
        "topicKey": "trial-institution-personnel"
    },
    {
        "id": "trials.trialId.trialinstitution.trialInstitutionId.notes",
        "path": "/trials/:trialId/trialinstitution/:trialInstitutionId/notes",
        "topicKey": "trial-institution-notes"
    },
    {
        "id": "trials.trialId.trialinstitution.trialInstitutionId.notes.noteId.details",
        "path": "/trials/:trialId/trialinstitution/:trialInstitutionId/notes/:noteId/details",
        "topicKey": "note"
    },
    {
        "id": "trials.trialId.trialinstitution.trialInstitutionId.labs",
        "path": "/trials/:trialId/trialinstitution/:trialInstitutionId/labs",
        "topicKey": "trial-institution-laboratories"
    },
    {
        "id": "trials.trialId.trialinstitution.trialInstitutionId.labs.trialInstitutionLaboratoryId.details",
        "path": "/trials/:trialId/trialinstitution/:trialInstitutionId/labs/:trialInstitutionLaboratoryId/details",
        "topicKey": "trial-institution-laboratory"
    },
    {
        "id": "trials.trialId.trialinstitution.trialInstitutionId.labs.trialInstitutionLaboratoryId.personnel",
        "path": "/trials/:trialId/trialinstitution/:trialInstitutionId/labs/:trialInstitutionLaboratoryId/personnel",
        "topicKey": "trial-institution-laboratory-personnels"
    },
    {
        "id": "trials.trialId.trialinstitution.trialInstitutionId.labs.trialInstitutionLaboratoryId.personnel.trialInstitutionLaboratoryPersonnelId.details",
        "path": "/trials/:trialId/trialinstitution/:trialInstitutionId/labs/:trialInstitutionLaboratoryId/personnel/:trialInstitutionLaboratoryPersonnelId/details",
        "topicKey": "trial-institution-laboratory-personnel"
    },
    {
        "id": "trials.trialId.trialinstitution.trialInstitutionId.labs.trialInstitutionLaboratoryId.finance",
        "path": "/trials/:trialId/trialinstitution/:trialInstitutionId/labs/:trialInstitutionLaboratoryId/finance",
        "topicKey": "trial-institution-laboratory-finance"
    },
    {
        "id": "trials.trialId.trialinstitution.trialInstitutionId.labs.trialInstitutionLaboratoryId.contracts",
        "path": "/trials/:trialId/trialinstitution/:trialInstitutionId/labs/:trialInstitutionLaboratoryId/contracts",
        "topicKey": "trial-institution-laboratory-contracts"
    },
    {
        "id": "trials.trialId.trialinstitution.trialInstitutionId.labs.trialInstitutionLaboratoryId.contracts.trialInstitutionLaboratoryContractId.details",
        "path": "/trials/:trialId/trialinstitution/:trialInstitutionId/labs/:trialInstitutionLaboratoryId/contracts/:trialInstitutionLaboratoryContractId/details",
        "topicKey": "trial-institution-laboratory-contract"
    },
    {
        "id": "trials.trialId.trialinstitution.trialInstitutionId.finance",
        "path": "/trials/:trialId/trialinstitution/:trialInstitutionId/finance",
        "topicKey": "trial-institution-finance"
    },
    {
        "id": "trials.trialId.trialinstitution.trialInstitutionId.contracts",
        "path": "/trials/:trialId/trialinstitution/:trialInstitutionId/contracts",
        "topicKey": "trial-institution-contracts"
    },
    {
        "id": "trials.trialId.trialinstitution.trialInstitutionId.contracts.trialInstitutionContractId.details",
        "path": "/trials/:trialId/trialinstitution/:trialInstitutionId/contracts/:trialInstitutionContractId/details",
        "topicKey": "trial-institution-contract"
    },
    {
        "id": "trials.trialId.trialinstitution.trialInstitutionId.monitoring",
        "path": "/trials/:trialId/trialinstitution/:trialInstitutionId/monitoring",
        "topicKey": "monitorings"
    },
    {
        "id": "trials.trialId.trialinstitution.trialInstitutionId.monitoring.monitoringId.details",
        "path": "/trials/:trialId/trialinstitution/:trialInstitutionId/monitoring/:monitoringId/details",
        "topicKey": "monitoring"
    },
    {
        "id": "trials.trialId.trialinstitution.trialInstitutionId.monitoring.monitoringId.documents",
        "path": "/trials/:trialId/trialinstitution/:trialInstitutionId/monitoring/:monitoringId/documents",
        "topicKey": "monitoring-documents"
    },
    {
        "id": "trials.trialId.trialinstitution.trialInstitutionId.monitoring.monitoringId.documents.monitoringDocumentId.details",
        "path": "/trials/:trialId/trialinstitution/:trialInstitutionId/monitoring/:monitoringId/documents/:monitoringDocumentId/details",
        "topicKey": "monitoring-document"
    },
    {
        "id": "trials.trialId.trialinstitution.trialInstitutionId.monitoring.monitoringId.issues",
        "path": "/trials/:trialId/trialinstitution/:trialInstitutionId/monitoring/:monitoringId/issues",
        "topicKey": "monitoring-issues"
    },
    {
        "id": "trials.trialId.trialinstitution.trialInstitutionId.monitoring.monitoringId.issues.monitoringIssueId.details",
        "path": "/trials/:trialId/trialinstitution/:trialInstitutionId/monitoring/:monitoringId/issues/:monitoringIssueId/details",
        "topicKey": "monitoring-issue"
    },
    {
        "id": "trials.trialId.trialinstitution.trialInstitutionId.monitoring.monitoringId.issues.monitoringIssueId.documents",
        "path": "/trials/:trialId/trialinstitution/:trialInstitutionId/monitoring/:monitoringId/issues/:monitoringIssueId/documents",
        "topicKey": "monitoring-issue-documents"
    },
    {
        "id": "trials.trialId.trialinstitution.trialInstitutionId.monitoring.monitoringId.issues.monitoringIssueId.documents.monitoringIssueDocumentId.details",
        "path": "/trials/:trialId/trialinstitution/:trialInstitutionId/monitoring/:monitoringId/issues/:monitoringIssueId/documents/:monitoringIssueDocumentId/details",
        "topicKey": "monitoring-issue-document"
    },
    {
        "id": "trials.trialId.trialinstitutionitemviews",
        "path": "/trials/:trialId/trialinstitutionitemviews",
        "topicKey": "trial-institution-item-custom-views"
    },
    {
        "id": "trials.trialId.trialinstitutionitemviews.trialInstitutionItemCustomViewId.dataentry",
        "path": "/trials/:trialId/trialinstitutionitemviews/:trialInstitutionItemCustomViewId/dataentry",
        "topicKey": "trial-institution-item-custom-view-data-entry"
    },
    {
        "id": "trials.trialId.trialinstitutionitemviews.trialInstitutionItemCustomViewId",
        "path": "/trials/:trialId/trialinstitutionitemviews/:trialInstitutionItemCustomViewId",
        "topicKey": "trial-institution-item-custom-view"
    },
    {
        "id": "trials.trialId.trialitems",
        "path": "/trials/:trialId/trialitems",
        "topicKey": "trial-items"
    },
    {
        "id": "trials.trialId.personnel",
        "path": "/trials/:trialId/personnel",
        "topicKey": "trial-personnel"
    },
    {
        "id": "trials.trialId.personnel.trialPersonnelId.details",
        "path": "/trials/:trialId/personnel/:trialPersonnelId/details",
        "topicKey": "trial-personnel"
    },
    {
        "id": "trials.trialId.accrual",
        "path": "/trials/:trialId/accrual",
        "topicKey": "trial-accruals"
    },
    {
        "id": "trials.trialId.notes",
        "path": "/trials/:trialId/notes",
        "topicKey": "trial-notes"
    },
    {
        "id": "trials.trialId.notes.noteId.details",
        "path": "/trials/:trialId/notes/:noteId/details",
        "topicKey": "note"
    },
    {
        "id": "trials.trialId.groups",
        "path": "/trials/:trialId/groups",
        "topicKey": "trial-groups"
    },
    {
        "id": "trials.trialId.groups.groupId.trialgroup.trialGroupId",
        "path": "/trials/:trialId/groups/:groupId/trialgroup/:trialGroupId",
        "topicKey": "dashboard"
    },
    {
        "id": "trials.trialId.groups.groupId.trialgroup.trialGroupId.details",
        "path": "/trials/:trialId/groups/:groupId/trialgroup/:trialGroupId/details",
        "topicKey": "trial-group"
    },
    {
        "id": "trials.trialId.groups.groupId.trialgroup.trialGroupId.personnel",
        "path": "/trials/:trialId/groups/:groupId/trialgroup/:trialGroupId/personnel",
        "topicKey": "trial-group-personnels"
    },
    {
        "id": "trials.trialId.groups.groupId.trialgroup.trialGroupId.personnel.trialPersonnelId.details",
        "path": "/trials/:trialId/groups/:groupId/trialgroup/:trialGroupId/personnel/:trialPersonnelId/details",
        "topicKey": "trial-group-personnel"
    },
    {
        "id": "trials.trialId.groups.groupId.trialgroup.trialGroupId.items",
        "path": "/trials/:trialId/groups/:groupId/trialgroup/:trialGroupId/items",
        "topicKey": "trial-group-items"
    },
    {
        "id": "trials.trialId.groups.groupId.trialgroup.trialGroupId.labs",
        "path": "/trials/:trialId/groups/:groupId/trialgroup/:trialGroupId/labs",
        "topicKey": "trial-group-laboratories"
    },
    {
        "id": "trials.trialId.groups.groupId.trialgroup.trialGroupId.labs.trialGroupLaboratoryId.details",
        "path": "/trials/:trialId/groups/:groupId/trialgroup/:trialGroupId/labs/:trialGroupLaboratoryId/details",
        "topicKey": "trial-group-laboratory"
    },
    {
        "id": "trials.trialId.groups.groupId.trialgroup.trialGroupId.labs.trialGroupLaboratoryId.personnel",
        "path": "/trials/:trialId/groups/:groupId/trialgroup/:trialGroupId/labs/:trialGroupLaboratoryId/personnel",
        "topicKey": "trial-group-laboratory-personnels"
    },
    {
        "id": "trials.trialId.groups.groupId.trialgroup.trialGroupId.labs.trialGroupLaboratoryId.personnel.trialGroupLaboratoryPersonnelId.details",
        "path": "/trials/:trialId/groups/:groupId/trialgroup/:trialGroupId/labs/:trialGroupLaboratoryId/personnel/:trialGroupLaboratoryPersonnelId/details",
        "topicKey": "trial-group-laboratory-personnel"
    },
    {
        "id": "trials.trialId.groups.groupId.trialgroup.trialGroupId.labs.trialGroupLaboratoryId.finance",
        "path": "/trials/:trialId/groups/:groupId/trialgroup/:trialGroupId/labs/:trialGroupLaboratoryId/finance",
        "topicKey": "trial-group-laboratory-finance"
    },
    {
        "id": "trials.trialId.groups.groupId.trialgroup.trialGroupId.labs.trialGroupLaboratoryId.contracts",
        "path": "/trials/:trialId/groups/:groupId/trialgroup/:trialGroupId/labs/:trialGroupLaboratoryId/contracts",
        "topicKey": "trial-group-laboratory-contracts"
    },
    {
        "id": "trials.trialId.groups.groupId.trialgroup.trialGroupId.labs.trialGroupLaboratoryId.contracts.trialGroupLaboratoryContractId.details",
        "path": "/trials/:trialId/groups/:groupId/trialgroup/:trialGroupId/labs/:trialGroupLaboratoryId/contracts/:trialGroupLaboratoryContractId/details",
        "topicKey": "trial-group-laboratory-contract"
    },
    {
        "id": "trials.trialId.groups.groupId.trialgroup.trialGroupId.finance",
        "path": "/trials/:trialId/groups/:groupId/trialgroup/:trialGroupId/finance",
        "topicKey": "trial-group-finance"
    },
    {
        "id": "trials.trialId.groups.groupId.trialgroup.trialGroupId.contracts",
        "path": "/trials/:trialId/groups/:groupId/trialgroup/:trialGroupId/contracts",
        "topicKey": "trial-group-contracts"
    },
    {
        "id": "trials.trialId.groups.groupId.trialgroup.trialGroupId.contracts.trialGroupContractId.details",
        "path": "/trials/:trialId/groups/:groupId/trialgroup/:trialGroupId/contracts/:trialGroupContractId/details",
        "topicKey": "trial-group-contract"
    },
    {
        "id": "trials.trialId.groups.trialGroupId",
        "path": "/trials/:trialId/groups/:trialGroupId",
        "topicKey": "dashboard"
    },
    {
        "id": "trials.trialId.groups.trialGroupId.details",
        "path": "/trials/:trialId/groups/:trialGroupId/details",
        "topicKey": "trial-group"
    },
    {
        "id": "trials.trialId.datasharing",
        "path": "/trials/:trialId/datasharing",
        "topicKey": "trial-doi"
    },
    {
        "id": "trials.trialId.website",
        "path": "/trials/:trialId/website",
        "topicKey": "trial-website"
    },
    {
        "id": "trials.trialId.finance",
        "path": "/trials/:trialId/finance",
        "topicKey": "trial-finance"
    },
    {
        "id": "trials.trialId.labs",
        "path": "/trials/:trialId/labs",
        "topicKey": "trial-laboratories"
    },
    {
        "id": "trials.projectId.project.details",
        "path": "/trials/:projectId/project/details",
        "topicKey": "project"
    },
    {
        "id": "trials.projectId.project.investigators.projectInvestigatorId.details",
        "path": "/trials/:projectId/project/investigators/:projectInvestigatorId/details",
        "topicKey": "project-investigator"
    },
    {
        "id": "trials.projectId.project.discussions",
        "path": "/trials/:projectId/project/discussions",
        "topicKey": "discussions"
    },
    {
        "id": "trials.projectId.project.discussions.discussionId.details",
        "path": "/trials/:projectId/project/discussions/:discussionId/details",
        "topicKey": "discussion"
    },
    {
        "id": "trials.projectId.project.items",
        "path": "/trials/:projectId/project/items",
        "topicKey": "project-items"
    },
    {
        "id": "committees",
        "path": "/committees",
        "topicKey": "committees"
    },
    {
        "id": "committees.committeeId.details",
        "path": "/committees/:committeeId/details",
        "topicKey": "committee"
    },
    {
        "id": "committees.committeeId.meetings",
        "path": "/committees/:committeeId/meetings",
        "topicKey": "committee-meetings"
    },
    {
        "id": "committees.committeeId.meetings.committeeMeetingId.details",
        "path": "/committees/:committeeId/meetings/:committeeMeetingId/details",
        "topicKey": "committee-meeting"
    },
    {
        "id": "committees.committeeId.meetings.committeeMeetingId.attendances",
        "path": "/committees/:committeeId/meetings/:committeeMeetingId/attendances",
        "topicKey": "committee-meeting-attendances"
    },
    {
        "id": "committees.committeeId.meetings.committeeMeetingId.attendances.committeeMeetingAttendanceId.details",
        "path": "/committees/:committeeId/meetings/:committeeMeetingId/attendances/:committeeMeetingAttendanceId/details",
        "topicKey": "committee-meeting-attendance"
    },
    {
        "id": "committees.committeeId.members",
        "path": "/committees/:committeeId/members",
        "topicKey": "committee-members"
    },
    {
        "id": "committees.committeeId.members.committeeMemberId.details",
        "path": "/committees/:committeeId/members/:committeeMemberId/details",
        "topicKey": "committee-member"
    },
    {
        "id": "committees.committeeId.members.committeeMemberId.roles",
        "path": "/committees/:committeeId/members/:committeeMemberId/roles",
        "topicKey": "committee-member-roles"
    },
    {
        "id": "committees.committeeId.members.committeeMemberId.roles.committeeMemberRoleId.details",
        "path": "/committees/:committeeId/members/:committeeMemberId/roles/:committeeMemberRoleId/details",
        "topicKey": "committee-member-role"
    },
    {
        "id": "committees.committeeId.regularinvitees",
        "path": "/committees/:committeeId/regularinvitees",
        "topicKey": "committee-regular-invitees"
    },
    {
        "id": "committees.committeeId.regularinvitees.committeeRegularInviteeId.details",
        "path": "/committees/:committeeId/regularinvitees/:committeeRegularInviteeId/details",
        "topicKey": "committee-regular-invitee"
    },
    {
        "id": "groups",
        "path": "/groups",
        "topicKey": "groups"
    },
    {
        "id": "groups.groupId.details",
        "path": "/groups/:groupId/details",
        "topicKey": "group"
    },
    {
        "id": "groups.groupId.trials",
        "path": "/groups/:groupId/trials",
        "topicKey": "group-trials"
    },
    {
        "id": "groups.groupId.trials.trialId.trialgroup.trialGroupId",
        "path": "/groups/:groupId/trials/:trialId/trialgroup/:trialGroupId",
        "topicKey": "dashboard"
    },
    {
        "id": "groups.groupId.trials.trialId.trialgroup.trialGroupId.details",
        "path": "/groups/:groupId/trials/:trialId/trialgroup/:trialGroupId/details",
        "topicKey": "trial-group"
    },
    {
        "id": "groups.groupId.trials.trialId.trialgroup.trialGroupId.personnel",
        "path": "/groups/:groupId/trials/:trialId/trialgroup/:trialGroupId/personnel",
        "topicKey": "trial-group-personnels"
    },
    {
        "id": "groups.groupId.trials.trialId.trialgroup.trialGroupId.personnel.trialPersonnelId.details",
        "path": "/groups/:groupId/trials/:trialId/trialgroup/:trialGroupId/personnel/:trialPersonnelId/details",
        "topicKey": "trial-group-personnel"
    },
    {
        "id": "groups.groupId.trials.trialId.trialgroup.trialGroupId.items",
        "path": "/groups/:groupId/trials/:trialId/trialgroup/:trialGroupId/items",
        "topicKey": "trial-group-items"
    },
    {
        "id": "groups.groupId.trials.trialId.trialgroup.trialGroupId.labs",
        "path": "/groups/:groupId/trials/:trialId/trialgroup/:trialGroupId/labs",
        "topicKey": "trial-group-laboratories"
    },
    {
        "id": "groups.groupId.trials.trialId.trialgroup.trialGroupId.labs.trialGroupLaboratoryId.details",
        "path": "/groups/:groupId/trials/:trialId/trialgroup/:trialGroupId/labs/:trialGroupLaboratoryId/details",
        "topicKey": "trial-group-laboratory"
    },
    {
        "id": "groups.groupId.trials.trialId.trialgroup.trialGroupId.labs.trialGroupLaboratoryId.personnel",
        "path": "/groups/:groupId/trials/:trialId/trialgroup/:trialGroupId/labs/:trialGroupLaboratoryId/personnel",
        "topicKey": "trial-group-laboratory-personnels"
    },
    {
        "id": "groups.groupId.trials.trialId.trialgroup.trialGroupId.labs.trialGroupLaboratoryId.personnel.trialGroupLaboratoryPersonnelId.details",
        "path": "/groups/:groupId/trials/:trialId/trialgroup/:trialGroupId/labs/:trialGroupLaboratoryId/personnel/:trialGroupLaboratoryPersonnelId/details",
        "topicKey": "trial-group-laboratory-personnel"
    },
    {
        "id": "groups.groupId.trials.trialId.trialgroup.trialGroupId.labs.trialGroupLaboratoryId.finance",
        "path": "/groups/:groupId/trials/:trialId/trialgroup/:trialGroupId/labs/:trialGroupLaboratoryId/finance",
        "topicKey": "trial-group-laboratory-finance"
    },
    {
        "id": "groups.groupId.trials.trialId.trialgroup.trialGroupId.labs.trialGroupLaboratoryId.contracts",
        "path": "/groups/:groupId/trials/:trialId/trialgroup/:trialGroupId/labs/:trialGroupLaboratoryId/contracts",
        "topicKey": "trial-group-laboratory-contracts"
    },
    {
        "id": "groups.groupId.trials.trialId.trialgroup.trialGroupId.labs.trialGroupLaboratoryId.contracts.trialGroupLaboratoryContractId.details",
        "path": "/groups/:groupId/trials/:trialId/trialgroup/:trialGroupId/labs/:trialGroupLaboratoryId/contracts/:trialGroupLaboratoryContractId/details",
        "topicKey": "trial-group-laboratory-contract"
    },
    {
        "id": "groups.groupId.trials.trialId.trialgroup.trialGroupId.finance",
        "path": "/groups/:groupId/trials/:trialId/trialgroup/:trialGroupId/finance",
        "topicKey": "trial-group-finance"
    },
    {
        "id": "groups.groupId.trials.trialId.trialgroup.trialGroupId.contracts",
        "path": "/groups/:groupId/trials/:trialId/trialgroup/:trialGroupId/contracts",
        "topicKey": "trial-group-contracts"
    },
    {
        "id": "groups.groupId.trials.trialId.trialgroup.trialGroupId.contracts.trialGroupContractId.details",
        "path": "/groups/:groupId/trials/:trialId/trialgroup/:trialGroupId/contracts/:trialGroupContractId/details",
        "topicKey": "trial-group-contract"
    },
    {
        "id": "groups.groupId.notes",
        "path": "/groups/:groupId/notes",
        "topicKey": "group-notes"
    },
    {
        "id": "groups.groupId.notes.noteId.details",
        "path": "/groups/:groupId/notes/:noteId/details",
        "topicKey": "note"
    },
    {
        "id": "groups.groupId.personnel",
        "path": "/groups/:groupId/personnel",
        "topicKey": "group-personnels"
    },
    {
        "id": "groups.groupId.personnel.trialPersonnelId.details",
        "path": "/groups/:groupId/personnel/:trialPersonnelId/details",
        "topicKey": "group-personnel"
    },
    {
        "id": "groups.groupId.contracts",
        "path": "/groups/:groupId/contracts",
        "topicKey": "group-contract"
    },
    {
        "id": "groups.groupId.finances",
        "path": "/groups/:groupId/finances",
        "topicKey": "group-finance"
    },
    {
        "id": "groups.groupId.items",
        "path": "/groups/:groupId/items",
        "topicKey": "group-items"
    },
    {
        "id": "personnel",
        "path": "/personnel",
        "topicKey": "personnels"
    },
    {
        "id": "personnel.byroles",
        "path": "/personnel/byroles",
        "topicKey": "personnel-by-roles"
    },
    {
        "id": "personnel.personnelId.details",
        "path": "/personnel/:personnelId/details",
        "topicKey": "personnel"
    },
    {
        "id": "personnel.personnelId.trainingcertifications",
        "path": "/personnel/:personnelId/trainingcertifications",
        "topicKey": "personnel-training-certification"
    },
    {
        "id": "personnel.personnelId.roles",
        "path": "/personnel/:personnelId/roles",
        "topicKey": "personnel-roles"
    },
    {
        "id": "personnel.personnelId.roles.personnelRoleId.details",
        "path": "/personnel/:personnelId/roles/:personnelRoleId/details",
        "topicKey": "personnel-role"
    },
    {
        "id": "personnel.personnelId.permissions",
        "path": "/personnel/:personnelId/permissions",
        "topicKey": "personnel-permissions"
    },
    {
        "id": "personnel.personnelId.activedirectory",
        "path": "/personnel/:personnelId/activedirectory",
        "topicKey": "personnel-active-directory"
    },
    {
        "id": "personnel.personnelId.notes",
        "path": "/personnel/:personnelId/notes",
        "topicKey": "personnel-notes"
    },
    {
        "id": "personnel.personnelId.notes.noteId.details",
        "path": "/personnel/:personnelId/notes/:noteId/details",
        "topicKey": "note"
    },
    {
        "id": "personnel.personnelId.fellowship",
        "path": "/personnel/:personnelId/fellowship",
        "topicKey": "fellowships"
    },
    {
        "id": "personnel.personnelId.fellowship.fellowshipId.details",
        "path": "/personnel/:personnelId/fellowship/:fellowshipId/details",
        "topicKey": "fellowship"
    },
    {
        "id": "projects",
        "path": "/projects",
        "topicKey": "projects"
    },
    {
        "id": "projects.projectId.details",
        "path": "/projects/:projectId/details",
        "topicKey": "project"
    },
    {
        "id": "projects.projectId.items",
        "path": "/projects/:projectId/items",
        "topicKey": "project-items"
    },
    {
        "id": "projects.projectId.investigators.projectInvestigatorId.details",
        "path": "/projects/:projectId/investigators/:projectInvestigatorId/details",
        "topicKey": "project-investigator"
    },
    {
        "id": "projects.projectId.discussions",
        "path": "/projects/:projectId/discussions",
        "topicKey": "discussions"
    },
    {
        "id": "projects.projectId.discussions.discussionId.details",
        "path": "/projects/:projectId/discussions/:discussionId/details",
        "topicKey": "discussion"
    },
    {
        "id": "institutions",
        "path": "/institutions",
        "topicKey": "institutions"
    },
    {
        "id": "institutions.institutionId.details",
        "path": "/institutions/:institutionId/details",
        "topicKey": "institution"
    },
    {
        "id": "institutions.institutionId.institutionitems",
        "path": "/institutions/:institutionId/institutionitems",
        "topicKey": "institution-items"
    },
    {
        "id": "institutions.institutionId.personnel",
        "path": "/institutions/:institutionId/personnel",
        "topicKey": "institution-personnels"
    },
    {
        "id": "institutions.institutionId.personnel.trialPersonnelId.details",
        "path": "/institutions/:institutionId/personnel/:trialPersonnelId/details",
        "topicKey": "institution-personnel"
    },
    {
        "id": "institutions.institutionId.labs",
        "path": "/institutions/:institutionId/labs",
        "topicKey": "institution-laboratories"
    },
    {
        "id": "institutions.institutionId.labs.institutionLaboratoryId.details",
        "path": "/institutions/:institutionId/labs/:institutionLaboratoryId/details",
        "topicKey": "institution-laboratory"
    },
    {
        "id": "institutions.institutionId.notes",
        "path": "/institutions/:institutionId/notes",
        "topicKey": "institution-notes"
    },
    {
        "id": "institutions.institutionId.notes.noteId.details",
        "path": "/institutions/:institutionId/notes/:noteId/details",
        "topicKey": "note"
    },
    {
        "id": "institutions.institutionId.procedures",
        "path": "/institutions/:institutionId/procedures",
        "topicKey": "institution-procedures"
    },
    {
        "id": "institutions.institutionId.procedures.institutionProcedureId.details",
        "path": "/institutions/:institutionId/procedures/:institutionProcedureId/details",
        "topicKey": "institution-procedure"
    },
    {
        "id": "institutions.institutionId.finance",
        "path": "/institutions/:institutionId/finance",
        "topicKey": "institution-finance"
    },
    {
        "id": "institutions.institutionId.contract",
        "path": "/institutions/:institutionId/contract",
        "topicKey": "institution-contract"
    },
    {
        "id": "institutions.institutionId.codes",
        "path": "/institutions/:institutionId/codes",
        "topicKey": "institution-codes"
    },
    {
        "id": "institutions.institutionId.codes.institutionCodeId",
        "path": "/institutions/:institutionId/codes/:institutionCodeId",
        "topicKey": "dashboard"
    },
    {
        "id": "institutions.institutionId.codes.institutionCodeId.details",
        "path": "/institutions/:institutionId/codes/:institutionCodeId/details",
        "topicKey": "institution-code"
    },
    {
        "id": "institutions.institutionId.trials",
        "path": "/institutions/:institutionId/trials",
        "topicKey": "institution-trials"
    },
    {
        "id": "labs",
        "path": "/labs",
        "topicKey": "labs"
    },
    {
        "id": "labs.laboratoryId.details",
        "path": "/labs/:laboratoryId/details",
        "topicKey": "lab"
    },
    {
        "id": "labs.laboratoryId.departments",
        "path": "/labs/:laboratoryId/departments",
        "topicKey": "lab-departments"
    },
    {
        "id": "labs.laboratoryId.departments.laboratoryDepartmentId.details",
        "path": "/labs/:laboratoryId/departments/:laboratoryDepartmentId/details",
        "topicKey": "lab-department"
    },
    {
        "id": "labs.laboratoryId.personnel",
        "path": "/labs/:laboratoryId/personnel",
        "topicKey": "lab-personnels"
    },
    {
        "id": "labs.laboratoryId.personnel.laboratoryPersonnelId.details",
        "path": "/labs/:laboratoryId/personnel/:laboratoryPersonnelId/details",
        "topicKey": "lab-personnel"
    },
    {
        "id": "labs.laboratoryId.institutions",
        "path": "/labs/:laboratoryId/institutions",
        "topicKey": "lab-institutions"
    },
    {
        "id": "labs.laboratoryId.institutions.institutionLaboratoryId.details",
        "path": "/labs/:laboratoryId/institutions/:institutionLaboratoryId/details",
        "topicKey": "lab-institutions"
    },
    {
        "id": "labs.laboratoryId.finance",
        "path": "/labs/:laboratoryId/finance",
        "topicKey": "lab-finance"
    },
    {
        "id": "labs.laboratoryId.contract",
        "path": "/labs/:laboratoryId/contract",
        "topicKey": "lab-contract"
    }
] as const;
export type HelpRouteId = typeof helpRouteCatalog[number]["id"];
export type HelpTopicKey = string;
export const defaultHelpDestination = (topicKey: string): HelpRouteId | undefined =>
    helpRouteCatalog.find(route => route.topicKey === topicKey)?.id;
export const helpRoutePermissionsById = {
    "dashboard": Dtos.Permission.DashboardView,
    "dashboard-preview": Dtos.Permission.DashboardView,
    "my-trial-institutions": Dtos.Permission.DashboardView,
    "search": null,
    "mytrials": Dtos.Permission.TrialView,
    "settings": Dtos.Permission.SettingsView,
    "settings.general": Dtos.Permission.GeneralSettingsView,
    "settings.general.countries": Dtos.Permission.CountriesView,
    "settings.general.countries.countryId": Dtos.Permission.CountriesView,
    "settings.general.roles": Dtos.Permission.RolesView,
    "settings.general.roles.roleId": Dtos.Permission.RolesView,
    "settings.general.states": Dtos.Permission.StatesView,
    "settings.general.states.stateId": Dtos.Permission.StatesView,
    "settings.general.itemcomponenttypes": Dtos.Permission.ItemComponentTypesView,
    "settings.general.itemcomponenttypes.itemcomponenttypesId": Dtos.Permission.ItemComponentTypesView,
    "settings.general.notetypes": Dtos.Permission.NoteTypesView,
    "settings.general.notetypes.notetypesId": Dtos.Permission.NoteTypesView,
    "settings.general.interests": Dtos.Permission.InterestsView,
    "settings.general.interests.interestId": Dtos.Permission.InterestsView,
    "settings.general.membershiptypes": Dtos.Permission.MembershipTypesView,
    "settings.general.membershiptypes.membershiptypesId": Dtos.Permission.MembershipTypesView,
    "settings.general.professionaldisciplines": Dtos.Permission.ProfessionalDisciplinesView,
    "settings.general.professionaldisciplines.professionaldisciplinesId": Dtos.Permission.ProfessionalDisciplinesView,
    "settings.general.salutations": Dtos.Permission.SalutationsView,
    "settings.general.salutations.salutationId": Dtos.Permission.SalutationsView,
    "settings.project": Dtos.Permission.ProjectSettingsView,
    "settings.project.itemtemplates": Dtos.Permission.ProjectItemTemplatesView,
    "settings.project.itemtemplates.projectItemTemplateId": Dtos.Permission.ProjectItemTemplatesView,
    "settings.project.itemcomponents": Dtos.Permission.ItemComponentsView,
    "settings.project.itemcomponents.itemComponentId": Dtos.Permission.ItemComponentsView,
    "settings.project.itemCategories": Dtos.Permission.ProjectItemCategoriesView,
    "settings.project.itemCategories.projectItemTemplateCategoryId": Dtos.Permission.ProjectItemCategoriesView,
    "settings.trial": Dtos.Permission.TrialSettingsView,
    "settings.trial.itemtemplates": Dtos.Permission.TrialItemView,
    "settings.trial.itemtemplates.trialId": Dtos.Permission.TrialItemView,
    "settings.trial.itemtemplates.trialId.template.trialItemTemplateId": Dtos.Permission.TrialItemView,
    "settings.trial.itemtemplates.template.trialItemTemplateId": Dtos.Permission.TrialItemView,
    "settings.trial.itemcomponents": Dtos.Permission.ItemComponentsView,
    "settings.trial.itemcomponents.itemComponentId": Dtos.Permission.ItemComponentsView,
    "settings.trial.itemtemplatecategories": Dtos.Permission.CategoriesView,
    "settings.trial.itemtemplatecategories.trialItemTemplateCategoryId": Dtos.Permission.CategoriesView,
    "settings.trial.trialtypes": Dtos.Permission.TrialTypesView,
    "settings.trial.trialtypes.trialTypeId": Dtos.Permission.TrialTypesView,
    "settings.trialinstitution": Dtos.Permission.TrialInstitutionSettingsView,
    "settings.trialinstitution.itemtemplates": Dtos.Permission.TrialInstitutionItemTemplatesView,
    "settings.trialinstitution.itemtemplates.trialId": Dtos.Permission.TrialInstitutionItemTemplatesView,
    "settings.trialinstitution.itemtemplates.trialId.template.trialInstitutionItemTemplateId": Dtos.Permission.TrialInstitutionItemTemplatesView,
    "settings.trialinstitution.itemtemplates.template.trialInstitutionItemTemplateId": Dtos.Permission.TrialInstitutionItemTemplatesView,
    "settings.trialinstitution.itemcomponents": Dtos.Permission.ItemComponentsView,
    "settings.trialinstitution.itemcomponents.itemComponentId": Dtos.Permission.ItemComponentsView,
    "settings.trialinstitution.itemtemplatecategories": Dtos.Permission.TrialInstitutionItemTemplateCategoriesView,
    "settings.trialinstitution.itemtemplatecategories.trialInstitutionItemTemplateCategoryId": Dtos.Permission.TrialInstitutionItemTemplateCategoriesView,
    "settings.trialgroup": Dtos.Permission.TrialGroupSettingsView,
    "settings.trialgroup.itemtemplates": Dtos.Permission.TrialGroupItemTemplatesView,
    "settings.trialgroup.itemtemplates.groupId": Dtos.Permission.TrialGroupItemTemplatesView,
    "settings.trialgroup.itemtemplates.groupId.template.trialGroupItemTemplateId": Dtos.Permission.TrialGroupItemTemplatesView,
    "settings.trialgroup.itemtemplates.template.trialGroupItemTemplateId": Dtos.Permission.TrialGroupItemTemplatesView,
    "settings.trialgroup.itemcomponents": Dtos.Permission.ItemComponentsView,
    "settings.trialgroup.itemcomponents.itemComponentId": Dtos.Permission.ItemComponentsView,
    "settings.trialgroup.itemtemplatecategories": Dtos.Permission.TrialGroupItemTemplateCategoriesView,
    "settings.trialgroup.itemtemplatecategories.trialGroupItemTemplateCategoryId": Dtos.Permission.TrialGroupItemTemplateCategoriesView,
    "settings.group": Dtos.Permission.GroupSettingsView,
    "settings.group.itemtemplates": Dtos.Permission.GroupItemTemplatesView,
    "settings.group.itemtemplates.groupId": Dtos.Permission.GroupItemTemplatesView,
    "settings.group.itemtemplates.groupId.template.groupItemTemplateId": Dtos.Permission.GroupItemTemplatesView,
    "settings.group.itemtemplates.template.groupItemTemplateId": Dtos.Permission.GroupItemTemplatesView,
    "settings.group.itemcomponents": Dtos.Permission.ItemComponentsView,
    "settings.group.itemcomponents.itemComponentId": Dtos.Permission.ItemComponentsView,
    "settings.group.itemCategories": Dtos.Permission.GroupItemCategoriesView,
    "settings.group.itemCategories.groupItemTemplateCategoryId": Dtos.Permission.GroupItemCategoriesView,
    "settings.institution": Dtos.Permission.InstitutionSettingsView,
    "settings.institution.itemtemplates": Dtos.Permission.InstitutionItemView,
    "settings.institution.itemtemplates.institutionId": Dtos.Permission.InstitutionItemView,
    "settings.institution.itemtemplates.institutionId.template.institutionItemTemplateId": Dtos.Permission.InstitutionItemView,
    "settings.institution.itemtemplates.template.institutionItemTemplateId": Dtos.Permission.InstitutionItemView,
    "settings.institution.itemcomponents": Dtos.Permission.ItemComponentsView,
    "settings.institution.itemcomponents.itemComponentId": Dtos.Permission.ItemComponentsView,
    "settings.institution.itemtemplatecategories": Dtos.Permission.InstitutionItemTemplateCategoriesView,
    "settings.institution.itemtemplatecategories.institutionItemTemplateCategoryId": Dtos.Permission.InstitutionItemTemplateCategoriesView,
    "settings.institution.sitelocations": Dtos.Permission.SiteLocationsView,
    "settings.institution.sitelocations.siteLocationId": Dtos.Permission.SiteLocationsView,
    "settings.institution.keycontacts": Dtos.Permission.KeyContactsView,
    "settings.institution.keycontacts.keyContactId": Dtos.Permission.KeyContactsView,
    "settings.institution.institutiontypes": Dtos.Permission.InstitutionTypesView,
    "settings.institution.institutiontypes.institutionTypeId": Dtos.Permission.InstitutionTypesView,
    "settings.institution.institutioncodings": Dtos.Permission.InstitutionCodingView,
    "settings.institution.institutioncodings.institutionCodingId": Dtos.Permission.InstitutionCodingView,
    "settings.hrecs": Dtos.Permission.HrecView,
    "settings.hrecs.hrecId.details": Dtos.Permission.HrecView,
    "settings.healthdistricts": Dtos.Permission.HealthDistrictView,
    "settings.healthdistricts.healthDistrictId.details": Dtos.Permission.HealthDistrictView,
    "trials": Dtos.Permission.TrialView,
    "trials.trialId.details": Dtos.Permission.TrialView,
    "trials.trialId.institutions": Dtos.Permission.TrialInstitutionView,
    "trials.trialId.trialinstitution.trialInstitutionId.details": Dtos.Permission.TrialInstitutionView,
    "trials.trialId.trialinstitution.trialInstitutionId.items": Dtos.Permission.TrialInstitutionItemView,
    "trials.trialId.trialinstitution.trialInstitutionId.personnel": Dtos.Permission.TrialPersonnelRoleView,
    "trials.trialId.trialinstitution.trialInstitutionId.personnel.personnelId.details": Dtos.Permission.TrialPersonnelRoleView,
    "trials.trialId.trialinstitution.trialInstitutionId.notes": Dtos.Permission.TrialNoteView,
    "trials.trialId.trialinstitution.trialInstitutionId.notes.noteId.details": Dtos.Permission.TrialNoteView,
    "trials.trialId.trialinstitution.trialInstitutionId.labs": Dtos.Permission.TrialInstitutionLabView,
    "trials.trialId.trialinstitution.trialInstitutionId.labs.trialInstitutionLaboratoryId.details": Dtos.Permission.TrialInstitutionLabView,
    "trials.trialId.trialinstitution.trialInstitutionId.labs.trialInstitutionLaboratoryId.personnel": Dtos.Permission.TrialInstitutionLabView,
    "trials.trialId.trialinstitution.trialInstitutionId.labs.trialInstitutionLaboratoryId.personnel.trialInstitutionLaboratoryPersonnelId.details": Dtos.Permission.TrialInstitutionLabView,
    "trials.trialId.trialinstitution.trialInstitutionId.labs.trialInstitutionLaboratoryId.finance": Dtos.Permission.TrialInstitutionLaboratoryFinanceView,
    "trials.trialId.trialinstitution.trialInstitutionId.labs.trialInstitutionLaboratoryId.contracts": Dtos.Permission.TrialInstitutionLaboratoryContractView,
    "trials.trialId.trialinstitution.trialInstitutionId.labs.trialInstitutionLaboratoryId.contracts.trialInstitutionLaboratoryContractId.details": Dtos.Permission.TrialInstitutionLaboratoryContractView,
    "trials.trialId.trialinstitution.trialInstitutionId.finance": Dtos.Permission.TrialInstitutionFinanceView,
    "trials.trialId.trialinstitution.trialInstitutionId.contracts": Dtos.Permission.TrialInstitutionContractView,
    "trials.trialId.trialinstitution.trialInstitutionId.contracts.trialInstitutionContractId.details": Dtos.Permission.TrialInstitutionContractView,
    "trials.trialId.trialinstitution.trialInstitutionId.monitoring": Dtos.Permission.MonitoringView,
    "trials.trialId.trialinstitution.trialInstitutionId.monitoring.monitoringId.details": Dtos.Permission.MonitoringView,
    "trials.trialId.trialinstitution.trialInstitutionId.monitoring.monitoringId.documents": Dtos.Permission.MonitoringDocumentView,
    "trials.trialId.trialinstitution.trialInstitutionId.monitoring.monitoringId.documents.monitoringDocumentId.details": Dtos.Permission.MonitoringDocumentView,
    "trials.trialId.trialinstitution.trialInstitutionId.monitoring.monitoringId.issues": Dtos.Permission.MonitoringIssueView,
    "trials.trialId.trialinstitution.trialInstitutionId.monitoring.monitoringId.issues.monitoringIssueId.details": Dtos.Permission.MonitoringIssueView,
    "trials.trialId.trialinstitution.trialInstitutionId.monitoring.monitoringId.issues.monitoringIssueId.documents": Dtos.Permission.MonitoringIssueDocumentView,
    "trials.trialId.trialinstitution.trialInstitutionId.monitoring.monitoringId.issues.monitoringIssueId.documents.monitoringIssueDocumentId.details": Dtos.Permission.MonitoringIssueDocumentView,
    "trials.trialId.trialinstitutionitemviews": Dtos.Permission.TrialItemView,
    "trials.trialId.trialinstitutionitemviews.trialInstitutionItemCustomViewId.dataentry": Dtos.Permission.TrialItemUpdate,
    "trials.trialId.trialinstitutionitemviews.trialInstitutionItemCustomViewId": Dtos.Permission.TrialItemUpdate,
    "trials.trialId.trialitems": Dtos.Permission.TrialItemView,
    "trials.trialId.personnel": Dtos.Permission.TrialPersonnelRoleView,
    "trials.trialId.personnel.trialPersonnelId.details": Dtos.Permission.TrialPersonnelRoleView,
    "trials.trialId.accrual": Dtos.Permission.TrialAccrualView,
    "trials.trialId.notes": Dtos.Permission.TrialNoteView,
    "trials.trialId.notes.noteId.details": Dtos.Permission.TrialNoteView,
    "trials.trialId.groups": Dtos.Permission.TrialGroupView,
    "trials.trialId.groups.groupId.trialgroup.trialGroupId": Dtos.Permission.DashboardView,
    "trials.trialId.groups.groupId.trialgroup.trialGroupId.details": Dtos.Permission.TrialGroupView,
    "trials.trialId.groups.groupId.trialgroup.trialGroupId.personnel": Dtos.Permission.TrialPersonnelRoleView,
    "trials.trialId.groups.groupId.trialgroup.trialGroupId.personnel.trialPersonnelId.details": Dtos.Permission.TrialPersonnelRoleView,
    "trials.trialId.groups.groupId.trialgroup.trialGroupId.items": Dtos.Permission.TrialGroupItemView,
    "trials.trialId.groups.groupId.trialgroup.trialGroupId.labs": Dtos.Permission.TrialGroupLabView,
    "trials.trialId.groups.groupId.trialgroup.trialGroupId.labs.trialGroupLaboratoryId.details": Dtos.Permission.TrialGroupLabView,
    "trials.trialId.groups.groupId.trialgroup.trialGroupId.labs.trialGroupLaboratoryId.personnel": Dtos.Permission.TrialGroupLabView,
    "trials.trialId.groups.groupId.trialgroup.trialGroupId.labs.trialGroupLaboratoryId.personnel.trialGroupLaboratoryPersonnelId.details": Dtos.Permission.TrialGroupLabView,
    "trials.trialId.groups.groupId.trialgroup.trialGroupId.labs.trialGroupLaboratoryId.finance": Dtos.Permission.TrialGroupLaboratoryFinanceView,
    "trials.trialId.groups.groupId.trialgroup.trialGroupId.labs.trialGroupLaboratoryId.contracts": Dtos.Permission.TrialGroupLaboratoryContractView,
    "trials.trialId.groups.groupId.trialgroup.trialGroupId.labs.trialGroupLaboratoryId.contracts.trialGroupLaboratoryContractId.details": Dtos.Permission.TrialGroupLaboratoryContractView,
    "trials.trialId.groups.groupId.trialgroup.trialGroupId.finance": Dtos.Permission.TrialGroupFinanceView,
    "trials.trialId.groups.groupId.trialgroup.trialGroupId.contracts": Dtos.Permission.TrialGroupContractView,
    "trials.trialId.groups.groupId.trialgroup.trialGroupId.contracts.trialGroupContractId.details": Dtos.Permission.TrialGroupContractView,
    "trials.trialId.groups.trialGroupId": Dtos.Permission.DashboardView,
    "trials.trialId.groups.trialGroupId.details": Dtos.Permission.TrialGroupView,
    "trials.trialId.datasharing": Dtos.Permission.TrialDoiView,
    "trials.trialId.website": Dtos.Permission.TrialWebsiteView,
    "trials.trialId.finance": Dtos.Permission.TrialFinanceView,
    "trials.trialId.labs": Dtos.Permission.TrialLaboratoryView,
    "trials.projectId.project.details": Dtos.Permission.ProjectView,
    "trials.projectId.project.investigators.projectInvestigatorId.details": Dtos.Permission.ProjectInvestigatorsView,
    "trials.projectId.project.discussions": Dtos.Permission.ProjectDiscussionView,
    "trials.projectId.project.discussions.discussionId.details": Dtos.Permission.ProjectDiscussionView,
    "trials.projectId.project.items": Dtos.Permission.ProjectItemsView,
    "committees": Dtos.Permission.CommitteeView,
    "committees.committeeId.details": Dtos.Permission.CommitteeView,
    "committees.committeeId.meetings": Dtos.Permission.CommitteeMeetingView,
    "committees.committeeId.meetings.committeeMeetingId.details": Dtos.Permission.CommitteeMeetingView,
    "committees.committeeId.meetings.committeeMeetingId.attendances": Dtos.Permission.CommitteeMeetingAttendanceView,
    "committees.committeeId.meetings.committeeMeetingId.attendances.committeeMeetingAttendanceId.details": Dtos.Permission.CommitteeMeetingAttendanceView,
    "committees.committeeId.members": Dtos.Permission.CommitteeMemberView,
    "committees.committeeId.members.committeeMemberId.details": Dtos.Permission.CommitteeMemberView,
    "committees.committeeId.members.committeeMemberId.roles": Dtos.Permission.CommitteeMemberRoleView,
    "committees.committeeId.members.committeeMemberId.roles.committeeMemberRoleId.details": Dtos.Permission.CommitteeMemberRoleView,
    "committees.committeeId.regularinvitees": Dtos.Permission.CommitteeRegularInviteeView,
    "committees.committeeId.regularinvitees.committeeRegularInviteeId.details": Dtos.Permission.CommitteeRegularInviteeView,
    "groups": Dtos.Permission.GroupView,
    "groups.groupId.details": Dtos.Permission.GroupView,
    "groups.groupId.trials": Dtos.Permission.TrialGroupView,
    "groups.groupId.trials.trialId.trialgroup.trialGroupId": Dtos.Permission.DashboardView,
    "groups.groupId.trials.trialId.trialgroup.trialGroupId.details": Dtos.Permission.TrialGroupView,
    "groups.groupId.trials.trialId.trialgroup.trialGroupId.personnel": Dtos.Permission.TrialPersonnelRoleView,
    "groups.groupId.trials.trialId.trialgroup.trialGroupId.personnel.trialPersonnelId.details": Dtos.Permission.TrialPersonnelRoleView,
    "groups.groupId.trials.trialId.trialgroup.trialGroupId.items": Dtos.Permission.TrialGroupItemView,
    "groups.groupId.trials.trialId.trialgroup.trialGroupId.labs": Dtos.Permission.TrialGroupLabView,
    "groups.groupId.trials.trialId.trialgroup.trialGroupId.labs.trialGroupLaboratoryId.details": Dtos.Permission.TrialGroupLabView,
    "groups.groupId.trials.trialId.trialgroup.trialGroupId.labs.trialGroupLaboratoryId.personnel": Dtos.Permission.TrialGroupLabView,
    "groups.groupId.trials.trialId.trialgroup.trialGroupId.labs.trialGroupLaboratoryId.personnel.trialGroupLaboratoryPersonnelId.details": Dtos.Permission.TrialGroupLabView,
    "groups.groupId.trials.trialId.trialgroup.trialGroupId.labs.trialGroupLaboratoryId.finance": Dtos.Permission.TrialGroupLaboratoryFinanceView,
    "groups.groupId.trials.trialId.trialgroup.trialGroupId.labs.trialGroupLaboratoryId.contracts": Dtos.Permission.TrialGroupLaboratoryContractView,
    "groups.groupId.trials.trialId.trialgroup.trialGroupId.labs.trialGroupLaboratoryId.contracts.trialGroupLaboratoryContractId.details": Dtos.Permission.TrialGroupLaboratoryContractView,
    "groups.groupId.trials.trialId.trialgroup.trialGroupId.finance": Dtos.Permission.TrialGroupFinanceView,
    "groups.groupId.trials.trialId.trialgroup.trialGroupId.contracts": Dtos.Permission.TrialGroupContractView,
    "groups.groupId.trials.trialId.trialgroup.trialGroupId.contracts.trialGroupContractId.details": Dtos.Permission.TrialGroupContractView,
    "groups.groupId.notes": Dtos.Permission.GroupNotesView,
    "groups.groupId.notes.noteId.details": Dtos.Permission.GroupNotesView,
    "groups.groupId.personnel": Dtos.Permission.GroupPersonnelRoleView,
    "groups.groupId.personnel.trialPersonnelId.details": Dtos.Permission.GroupPersonnelRoleView,
    "groups.groupId.contracts": Dtos.Permission.GroupContractView,
    "groups.groupId.finances": Dtos.Permission.GroupFinanceView,
    "groups.groupId.items": Dtos.Permission.GroupItemView,
    "personnel": Dtos.Permission.PersonnelView,
    "personnel.byroles": Dtos.Permission.PersonnelRoleView,
    "personnel.personnelId.details": Dtos.Permission.PersonnelView,
    "personnel.personnelId.trainingcertifications": Dtos.Permission.TrainingCertificationsView,
    "personnel.personnelId.roles": Dtos.Permission.PersonnelRoleView,
    "personnel.personnelId.roles.personnelRoleId.details": Dtos.Permission.PersonnelRoleView,
    "personnel.personnelId.permissions": Dtos.Permission.PersonnelRoleView,
    "personnel.personnelId.activedirectory": Dtos.Permission.PersonnelSecurityView,
    "personnel.personnelId.notes": Dtos.Permission.PersonnelNoteView,
    "personnel.personnelId.notes.noteId.details": Dtos.Permission.PersonnelNoteView,
    "personnel.personnelId.fellowship": Dtos.Permission.FellowshipView,
    "personnel.personnelId.fellowship.fellowshipId.details": Dtos.Permission.FellowshipView,
    "projects": Dtos.Permission.ProjectView,
    "projects.projectId.details": Dtos.Permission.ProjectView,
    "projects.projectId.items": Dtos.Permission.ProjectItemsView,
    "projects.projectId.investigators.projectInvestigatorId.details": Dtos.Permission.ProjectInvestigatorsView,
    "projects.projectId.discussions": Dtos.Permission.ProjectDiscussionView,
    "projects.projectId.discussions.discussionId.details": Dtos.Permission.ProjectDiscussionView,
    "institutions": Dtos.Permission.InstitutionView,
    "institutions.institutionId.details": Dtos.Permission.InstitutionView,
    "institutions.institutionId.institutionitems": Dtos.Permission.InstitutionItemView,
    "institutions.institutionId.personnel": Dtos.Permission.InstitutionPersonnelView,
    "institutions.institutionId.personnel.trialPersonnelId.details": Dtos.Permission.InstitutionPersonnelView,
    "institutions.institutionId.labs": Dtos.Permission.LabInstitutionView,
    "institutions.institutionId.labs.institutionLaboratoryId.details": Dtos.Permission.LabInstitutionView,
    "institutions.institutionId.notes": Dtos.Permission.InstitutionNoteView,
    "institutions.institutionId.notes.noteId.details": Dtos.Permission.InstitutionNoteView,
    "institutions.institutionId.procedures": Dtos.Permission.InstitutionProcedureView,
    "institutions.institutionId.procedures.institutionProcedureId.details": Dtos.Permission.InstitutionProcedureView,
    "institutions.institutionId.finance": Dtos.Permission.InstitutionFinanceView,
    "institutions.institutionId.contract": Dtos.Permission.InstitutionContractView,
    "institutions.institutionId.codes": Dtos.Permission.InstitutionCodeView,
    "institutions.institutionId.codes.institutionCodeId": Dtos.Permission.DashboardView,
    "institutions.institutionId.codes.institutionCodeId.details": Dtos.Permission.InstitutionCodeView,
    "institutions.institutionId.trials": Dtos.Permission.TrialInstitutionView,
    "labs": Dtos.Permission.LabView,
    "labs.laboratoryId.details": Dtos.Permission.LabDetailsView,
    "labs.laboratoryId.departments": Dtos.Permission.LabDepartmentView,
    "labs.laboratoryId.departments.laboratoryDepartmentId.details": Dtos.Permission.LabDepartmentView,
    "labs.laboratoryId.personnel": Dtos.Permission.LabPersonnelView,
    "labs.laboratoryId.personnel.laboratoryPersonnelId.details": Dtos.Permission.LabPersonnelView,
    "labs.laboratoryId.institutions": Dtos.Permission.LabInstitutionView,
    "labs.laboratoryId.institutions.institutionLaboratoryId.details": Dtos.Permission.LabInstitutionView,
    "labs.laboratoryId.finance": Dtos.Permission.LabFinanceView,
    "labs.laboratoryId.contract": Dtos.Permission.LabContractView
} as const;
export const helpRoutePermission = (routeId: string): Dtos.Permission | null | undefined => {
    const permission = helpRoutePermissionsById[routeId as keyof typeof helpRoutePermissionsById];
    if (permission === undefined || permission === null) return permission;
    return typeof permission === "number"
        ? permission
        : Dtos.Permission[permission as keyof typeof Dtos.Permission] as Dtos.Permission;
};
